import React from 'react';

export const About = () => {
  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-5xl font-extrabold text-navy mb-4">
            About Us
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
            Redefining professional networking with innovative NFC technology
          </p>
        </div>
        
        <div className="text-center mb-16">
        <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
          Our company "Smart Connections" based in the Cayman Islands, is redefining professional 
          networking. Our NFC-enabled sleek, and elegant cards help to connect instantly, and sustainably 
          with a simple tap or scan. Our networking solutions allow professionals across to share contact 
          details seamlessly, without the need for apps or outdated methods.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 mb-16">
        {/* Customize Card */}
        <div className="bg-yellow-custom rounded-[2rem] p-8">
          <h3 className="text-2xl font-bold text-navy mb-4">
            Customize and Design<br />
            your card.<br />
            Make it unique
          </h3>
          <div className="mt-8 bg-white rounded-xl p-4 h-48" />
        </div>

        {/* NFC Cards */}
        <div className="rounded-[2rem] p-8" style={{ backgroundColor: 'hsl(220, 40%, 88%)' }}>
          <h3 className="text-2xl font-bold text-navy mb-4">
            Why NFC Business Cards
          </h3>
          <p className="text-base text-gray-600 mb-6">
            Our NFC-enabled cards let you share your contact details, portfolio, or social profiles with a single tap.
          </p>
          <div className="mt-8 bg-white rounded-xl p-4 h-32 flex items-center justify-center">
            <div className="w-24 h-24 bg-blue-600 rounded-full" />
          </div>
        </div>

        {/* Philosophy */}
        <div className="bg-purple-custom rounded-[2rem] p-8">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-2xl font-bold text-navy">
              Our Philosophy
            </h3>
            <span className="text-2xl">→</span>
          </div>
          <div className="space-y-2">
            <span className="inline-block bg-white px-4 py-2 rounded-full text-sm font-semibold mr-2 mb-2">Innovation</span>
            <span className="inline-block bg-white px-4 py-2 rounded-full text-sm font-semibold mr-2 mb-2">Sustainability</span>
            <span className="inline-block bg-white px-4 py-2 rounded-full text-sm font-semibold mr-2 mb-2">Efficiency</span>
            <span className="inline-block bg-white px-4 py-2 rounded-full text-sm font-semibold mr-2 mb-2">Impact</span>
          </div>
          <div className="mt-8 bg-coral rounded-xl p-4 h-32" />
        </div>
      </div>

      {/* Commitment */}
      <div className="rounded-[2rem] p-12 text-center" style={{ backgroundColor: 'hsl(350, 60%, 88%)' }}>
        <h2 className="text-4xl font-extrabold text-navy mb-4">
          Our Commitment
        </h2>
        <p className="text-2xl font-bold text-gray-700">
          Design. Quality. Excellence.
        </p>
      </div>
      </div>
    </section>
  );
};
